import React from 'react';
import { useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import {
  selectUserModalShow,
  selectUserModalTitle,
  selectUserModalUser,
} from 'redux/reducers/userModalReducer';
import onModalHide from 'components/Admin/Users/UserModal/utils';
import UserForm from 'components/Admin/Users/UserModal/UserForm';

export default function FormSheet() {
  const user = useSelector(selectUserModalUser);
  const title = useSelector(selectUserModalTitle);
  const show = useSelector(selectUserModalShow);

  return (
    <BottomSheet open={show} dismiss={onModalHide} title={title}>
      <UserForm user={user} />
    </BottomSheet>
  );
}
